import styled from "styled-components"

import CheckBox from "components/presenters/button/CheckBox"

export default function DefaultShippingCheckBox({ onCheck, isChangeDefault }) {
  return (
    <CheckBoxLabel htmlFor="default-address">
      <CheckBox id="default-address" onChange={onCheck} circle checked={isChangeDefault} />
      현재 배송지를 기본 배송지로 저장
    </CheckBoxLabel>
  )
}

const CheckBoxLabel = styled.label`
  display: flex;
  align-items: center;
  margin-top: calc(100vw * (26 / 375));
  font-size: calc(100vw * (14 / 375));
  font-weight: 500;
  line-height: calc(100vw * (16 / 375));
  color: #7f7f7f;
`
